/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ModelRegistryLimitsTraitDTO
 */
export interface ModelRegistryLimitsTraitDTO {
    /**
     * 
     * @type {number}
     * @memberof ModelRegistryLimitsTraitDTO
     */
    maxModelsPerProject?: number;
}

/**
 * Check if a given object implements the ModelRegistryLimitsTraitDTO interface.
 */
export function instanceOfModelRegistryLimitsTraitDTO(value: object): value is ModelRegistryLimitsTraitDTO {
    return true;
}

export function ModelRegistryLimitsTraitDTOFromJSON(json: any): ModelRegistryLimitsTraitDTO {
    return ModelRegistryLimitsTraitDTOFromJSONTyped(json, false);
}

export function ModelRegistryLimitsTraitDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModelRegistryLimitsTraitDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'maxModelsPerProject': json['maxModelsPerProject'] == null ? undefined : json['maxModelsPerProject'],
    };
}

export function ModelRegistryLimitsTraitDTOToJSON(value?: ModelRegistryLimitsTraitDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'maxModelsPerProject': value['maxModelsPerProject'],
    };
}

